
function init(opcoes) {
    $('.bussola-slider').owlCarousel(opcoes)
}

function destroy() {
    $('.bussola-slider').owlCarousel('destroy')
}

module.exports = {
    init,
    destroy
}


// WEBPACK FOOTER //
// ./resources/assets/layout-novo/js/modulo/carrossel.js